import { Component, OnInit, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, AbstractControl, FormArray } from '@angular/forms'; import { Router, ActivatedRoute, RouterModule } from '@angular/router';
import { Pattern } from '@app/shared/validators/pattern';
import { LoaderService } from '@app/core/services/loader/loader.service';
import { NotificationService } from '@app/core/services/notification/notification.service';
import { CommonService } from '@app/shared/services/common/common.service';
import { MatDialog } from '@angular/material/dialog';
import { ICategoryInterface, ISubCategoryInterface, IUnitInterface, ICategoryListInterface, IColorInterface } from '../add-product-popup/IStoreList.interface';
import { UploadProductImageDialogComponent } from '../upload-product-image-dialog/upload-product-image-dialog.component';
import { CustomProductImageInterface } from '../../../../shared/services/product/uploadProductImages.interface';
import { ProductService } from '../../../../shared/services/product/product.service';
import { environment } from '@env/environment';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { WarehouseImageModel, WarehouseSizeModel, WarehouseVarientModel } from '@app/shared/models/product';
import { ImageCroppedEvent } from 'ngx-image-cropper';


@Component({
  selector: 'app-add-custom-product',
  templateUrl: './add-custom-product.component.html',
  styleUrls: ['./add-custom-product.component.css']
})
export class AddCustomProductComponent implements OnInit {
  catgList!: any[];
  Units !: any[];
  settings = {};
  colorSettings = {};
  subCateSettings = {};
  test: any;
  testId: any;
  dropdownList: ICategoryInterface[];
  colorDropdownList: IColorInterface[];
  dropdownListSubCategory: ISubCategoryInterface[] = [];
  categoryList: ICategoryListInterface[] = [];
  //images: CustomProductImageInterface[] = [];
  uploadForm: FormGroup;
  ImageHashCombination: WarehouseVarientModel[] = [];
  styleId: number;
  addCustomProductForm: FormGroup;
  UserId: any;
  currencies !: any[];
  lenghtPlaceholder: any;
  weightPlaceholder: any;
  ProductId: string;
  //@ViewChild('inputImage') inputImageVariable!: any;
  //@ViewChild('inputImageEdit') inputImageVariableEdit!: any;

  @ViewChildren('inputImage') inputImageVariable: QueryList<any>;
  Status: any;
  selectedItems = [];
  varientValues: any;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];


  constructor(private formBuilder: FormBuilder, private router: Router, private loader: LoaderService, private activatedRoute: ActivatedRoute,
    private notificationService: NotificationService, private route: Router, private dialog: MatDialog, private commonService: CommonService, private productService: ProductService) {
    this.UserId = localStorage.getItem('userId');
    this.lenghtPlaceholder = "in";
    this.weightPlaceholder = "oz";
    this.Units = this.getUnits();
    this.currencies = ['USD', 'EUR'];
    this.addCustomProductForm = this.formBuilder.group({
      Title: new FormControl('', Validators.compose([Validators.required, Validators.pattern(Pattern.PRODUCT_TITLE_PATTERN)])),
      Description: new FormControl('', Validators.required),
      SKU: new FormControl(''),
      RetailPrice: new FormControl(0, Validators.compose([Validators.required, Validators.pattern(Pattern.CURRENCY_PATTERN)])),
      ProductCategories: new FormControl(this.dropdownList, Validators.required),
      Productsubcategories: new FormControl(this.dropdownListSubCategory, Validators.required),
      UnitId: new FormControl(1),
      IsPackaged: new FormControl(false),
      Length: new FormControl('', Validators.compose([Validators.required, Validators.pattern(Pattern.CURRENCY_PATTERN)])),
      Height: new FormControl('', Validators.compose([Validators.required, Validators.pattern(Pattern.CURRENCY_PATTERN)])),
      Weight: new FormControl('', Validators.compose([Validators.required, Validators.pattern(Pattern.CURRENCY_PATTERN)])),
      Width: new FormControl('', Validators.compose([Validators.required, Validators.pattern(Pattern.CURRENCY_PATTERN)])),
      //file: ['', Validators.required],
      rows: this.formBuilder.array([])
    });

  }

  ngOnInit() {
    this.activatedRoute.params.subscribe(params =>
      this.ProductId = params['productid']
    );
    this.varientValues = [[], []];

    if (this.ProductId != undefined) {
      this.fn_UpdateCustomForm(this.ProductId);
    } else {
      this.fn_GetCategories();
    }
    this.initGroup(true);


    this.settings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      idFieldopt: 'CategoryId',
      enableCheckAll: false,
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 3,
      searchPlaceholderText: 'Search Categories',
      noDataAvailablePlaceholderText: 'No items',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: true,
      defaultOpen: false
    };
    this.subCateSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      idFieldopt: 'CategoryId',
      enableCheckAll: false,
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 3,
      searchPlaceholderText: 'Search Sub Categories',
      noDataAvailablePlaceholderText: 'Please Choose Category',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: true,
      defaultOpen: false
    };

    this.colorSettings = {
      singleSelection: false,
      idField: 'ColorName',
      textField: 'ColorName',
      idFieldopt: 'ColorName',
      enableCheckAll: false,
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      maxwidth: 200,
      itemsShowLimit: 10,
      searchPlaceholderText: 'Search Colors',
      noDataAvailablePlaceholderText: 'No Colors',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: true,
      defaultOpen: false
    };
  }

  addChip(event: any, index: number): void {
    const input = event.input;
    var value = event.value;
    if (value == undefined)
      value = event.ColorName;
    // Add varient
    if ((value || '').trim()) {
      if (!this.varientValues[index].includes(value.trim()))
        this.varientValues[index].push(value.trim());
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
    this.fn_MapVariantToDisplay();

  }

  removeChip(val: string, index: number): void {
    const optIndex = this.varientValues[index].indexOf(val);

    if (optIndex >= 0) {
      this.varientValues[index].splice(optIndex, 1);
    }
    this.fn_MapVariantToDisplay();
  }

  addColor(color: any, index: number): void {
    var value = color ? color.ColorName : '';
    if ((value || '').trim()) {
      if (!this.varientValues[index].includes(value.trim()))
        this.varientValues[index].push(value.trim());
    }
    this.fn_MapVariantToDisplay();
  }
  removeColor(val: any, index: number): void {
    const optIndex = this.varientValues[index].indexOf(val.ColorName);

    if (optIndex >= 0) {
      this.varientValues[index].splice(optIndex, 1);
    }
    this.fn_MapVariantToDisplay();
  }

  fn_MapVariantToDisplay() {

    var temp = this.ImageHashCombination;   
    this.ImageHashCombination = [];//remove everything will fill again   
    //Add this to array
    let colorList = this.varientValues[0];
    let sizeList = this.varientValues[1];

    colorList.forEach((color) => { 
      let sizes: WarehouseSizeModel[] = [];

      Object.keys(sizeList).forEach((i) => {
        sizes.push({ Id: 0, Size: sizeList[i] })
      });
      let results: WarehouseSizeModel[] = [];
      var filledData = temp.find(x => x.Color == color.ColorName);//map old values if there where else set defualt      
      this.ImageHashCombination.push({
        Id: filledData != undefined ? filledData.Id:0,
        Color: color.ColorName,
        HexCode: filledData != undefined ? filledData.HexCode : this.colourNameToHex(color.ColorName),       
        Sizes: sizes,
        images: filledData != undefined ? filledData.images : [],
        cropperReady: filledData != undefined ? filledData.cropperReady : false,
        croppedImage: filledData != undefined ? filledData.croppedImage : '',
        deletedImages: filledData != undefined ? filledData.deletedImages : [],
        imageChangedEvent: filledData != undefined ? filledData.imageChangedEvent : ''
      });
    });

  }

  fn_UpdateCustomForm(productId: string) {
    this.loader.show();
    this.productService.getCustomProductsDetails(productId).subscribe((res: any) => {
      if (res.StatusCode == 200) {
        let cat = [];
        let subCat = [];
        var catData = res.Data.ResponseData.Categories;
        for (var i = 0; i < catData.length; i++) {
          cat.push({ item_id: catData[i].CategoryId.toString(), item_text: catData[i].CategoryName });
          for (var j = 0; j < catData[i].SubCatetgoryList.length; j++) {
            subCat.push({ item_id: catData[i].SubCatetgoryList[j].SubCategoryId.toString(), item_text: catData[i].SubCatetgoryList[j].SubCategoryName, CategoryId: catData[i].SubCatetgoryList[j].CategoryId });
          }
        } this.fn_GetCategories();
        this.fn_GetSubCAtegories(cat);
        //this.fn_setWarehouseVariant(res.Data.ResponseData.WarehouseVariants)
        this.addCustomProductForm.patchValue({
          Title: res.Data.ResponseData.Title,
          Description: res.Data.ResponseData.Description,
          SKU: res.Data.ResponseData.SKU,
          RetailPrice: res.Data.ResponseData.RetailPrice,
          IsPackaged: res.Data.ResponseData.IsPackaged,
          Height: res.Data.ResponseData.Height,
          Weight: res.Data.ResponseData.Weight,
          Width: res.Data.ResponseData.Width,
          Length: res.Data.ResponseData.Length,
          Productsubcategories: subCat,
          ProductCategories: cat,
          UnitId: res.Data.ResponseData.UnitId,
        });
        const imageInitials =  environment.warehouseProductCustomImageFolder;

        let allColors: string[] = [];
        let allSizes: string[] = [];
        res.Data.ResponseData.WarehouseVariants.forEach(variant => {  
          let sizes: WarehouseSizeModel[] = [];
          let images: WarehouseImageModel[] = [];
          this.varientValues[0].push({ ColorName : variant.ColorName });
          variant.Size.forEach((size) => {
            sizes.push({ Id: size.SizeId, Size: size.SizeName });
            if (this.varientValues[1].indexOf(size.SizeName) == -1) {
              this.varientValues[1].push(size.SizeName);
            }
          });
          variant.WarehouseProductImages.forEach((image) => {
            images.push({ Id: image.ImageId, Image: imageInitials + image.ImageName, IsAdded: false });
          });

          this.ImageHashCombination.push({
            Id: variant.StyleId,
            Color: variant.ColorName,
            HexCode: variant.HexCode,
            Sizes: sizes,
            images: images,
            cropperReady: false,
            croppedImage: '',
            deletedImages: [],
            imageChangedEvent: ''
          });
        });

        let rows = this.addCustomProductForm.get('rows') as FormArray;
        //Let show the default two rows for varient, ie. colors and Sizes
        rows.push(this.formBuilder.group({
          optionName: "Colors",
          optionValue: [null],
        }));
        rows.push(this.formBuilder.group({
          optionName: "Size",
          optionValue: [''],
        }));

        // remove validation in edit for file
        // this.addCustomProductForm.get('file').clearValidators();
        // this.addCustomProductForm.get('file').updateValueAndValidity();
        //this.images = this.mapImageForProduct(res.Data.ResponseData.WarehouseProductImages);

        this.Status = res.Data.ResponseData.Status == 2 ? "Approved" : "Rejected";
        // this.Categories = res.Data.ResponseData[0].Categories;

        this.loader.hide();
      }
    });
  }

  fn_setWarehouseVariant(WarehouseVariants: any) {
    let rows = this.addCustomProductForm.get('rows') as FormArray;
    Object.keys(WarehouseVariants).forEach((i) => {
      if (Number(i) == 0) {
        rows.push(
          this.formBuilder.group({
            VarientId: new FormControl({ value: WarehouseVariants[i].StyleId, disabled: false }),
            optionName: new FormControl({ value: WarehouseVariants[i].OptionName, disabled: false }),
            optionValue: new FormControl({ value: '', disabled: false })
          })
        )
      }
      else {

      }
      WarehouseVariants[i].Size.forEach(variant => {
      });

      if (Number(i) == 0)
        this.varientValues[i] = WarehouseVariants[i].OptionValue.split(',');
      if (Number(i) == 1)
        this.varientValues[i] = WarehouseVariants[i].OptionValue.split(',');
    })
  }

  mapImageForProduct(res: any[]): CustomProductImageInterface[] {
    return res.reduce((arr: CustomProductImageInterface[], x: any) => {
      const apiBaseUrl = environment.warehouseProductCustomImageFolder;
      let imagePath = apiBaseUrl + x.ImageName;
      arr.push({
        Id: x.ImageId,
        Image: imagePath,
        IsActive: true,
        IsDefault: false,
        IsCustom: false,
        IsAdded: false,
        IsEdited: false,
        StyleId: 0,
        UniqueStyleId: 0
      });
      return arr;
    }, []);
  }
  mapImages(res: any[]): string[] {
    return res.reduce((arr: string[], x: any) => {
      let imagePath = environment.warehouseProductCustomImageFolder + x.ImageName;
      arr.push(imagePath);
      return arr;
    }, []);
  }

  fn_AddVariant() {
    let rows = this.addCustomProductForm.get('rows') as FormArray;
    if (rows.length == 0)
      this.initGroup(false);
  }

  public UpdatePlaceholders(id: any) {
    if (id == 1) {
      this.weightPlaceholder = "oz";
      this.lenghtPlaceholder = "in";
    }
    else {
      this.weightPlaceholder = "g";
      this.lenghtPlaceholder = "cm";
    }
  }

  public colourNameToHex(colour: any) {
    var colours = {
      "aliceblue": "#f0f8ff", "antiquewhite": "#faebd7", "aqua": "#00ffff", "aquamarine": "#7fffd4", "azure": "#f0ffff",
      "beige": "#f5f5dc", "bisque": "#ffe4c4", "black": "#000000", "blanchedalmond": "#ffebcd", "blue": "#0000ff", "blueviolet": "#8a2be2", "brown": "#a52a2a", "burlywood": "#deb887",
      "cadetblue": "#5f9ea0", "chartreuse": "#7fff00", "chocolate": "#d2691e", "coral": "#ff7f50", "cornflowerblue": "#6495ed", "cornsilk": "#fff8dc", "crimson": "#dc143c", "cyan": "#00ffff",
      "darkblue": "#00008b", "darkcyan": "#008b8b", "darkgoldenrod": "#b8860b", "darkgray": "#a9a9a9", "darkgreen": "#006400", "darkkhaki": "#bdb76b", "darkmagenta": "#8b008b", "darkolivegreen": "#556b2f",
      "darkorange": "#ff8c00", "darkorchid": "#9932cc", "darkred": "#8b0000", "darksalmon": "#e9967a", "darkseagreen": "#8fbc8f", "darkslateblue": "#483d8b", "darkslategray": "#2f4f4f", "darkturquoise": "#00ced1",
      "darkviolet": "#9400d3", "deeppink": "#ff1493", "deepskyblue": "#00bfff", "dimgray": "#696969", "dodgerblue": "#1e90ff",
      "firebrick": "#b22222", "floralwhite": "#fffaf0", "forestgreen": "#228b22", "fuchsia": "#ff00ff",
      "gainsboro": "#dcdcdc", "ghostwhite": "#f8f8ff", "gold": "#ffd700", "goldenrod": "#daa520", "gray": "#808080", "green": "#008000", "greenyellow": "#adff2f",
      "honeydew": "#f0fff0", "hotpink": "#ff69b4",
      "indianred ": "#cd5c5c", "indigo": "#4b0082", "ivory": "#fffff0", "khaki": "#f0e68c",
      "lavender": "#e6e6fa", "lavenderblush": "#fff0f5", "lawngreen": "#7cfc00", "lemonchiffon": "#fffacd", "lightblue": "#add8e6", "lightcoral": "#f08080", "lightcyan": "#e0ffff", "lightgoldenrodyellow": "#fafad2",
      "lightgrey": "#d3d3d3", "lightgreen": "#90ee90", "lightpink": "#ffb6c1", "lightsalmon": "#ffa07a", "lightseagreen": "#20b2aa", "lightskyblue": "#87cefa", "lightslategray": "#778899", "lightsteelblue": "#b0c4de",
      "lightyellow": "#ffffe0", "lime": "#00ff00", "limegreen": "#32cd32", "linen": "#faf0e6",
      "magenta": "#ff00ff", "maroon": "#800000", "mediumaquamarine": "#66cdaa", "mediumblue": "#0000cd", "mediumorchid": "#ba55d3", "mediumpurple": "#9370d8", "mediumseagreen": "#3cb371", "mediumslateblue": "#7b68ee",
      "mediumspringgreen": "#00fa9a", "mediumturquoise": "#48d1cc", "mediumvioletred": "#c71585", "midnightblue": "#191970", "mintcream": "#f5fffa", "mistyrose": "#ffe4e1", "moccasin": "#ffe4b5",
      "navajowhite": "#ffdead", "navy": "#000080",
      "oldlace": "#fdf5e6", "olive": "#808000", "olivedrab": "#6b8e23", "orange": "#ffa500", "orangered": "#ff4500", "orchid": "#da70d6",
      "palegoldenrod": "#eee8aa", "palegreen": "#98fb98", "paleturquoise": "#afeeee", "palevioletred": "#d87093", "papayawhip": "#ffefd5", "peachpuff": "#ffdab9", "peru": "#cd853f", "pink": "#ffc0cb", "plum": "#dda0dd", "powderblue": "#b0e0e6", "purple": "#800080",
      "rebeccapurple": "#663399", "red": "#ff0000", "rosybrown": "#bc8f8f", "royalblue": "#4169e1",
      "saddlebrown": "#8b4513", "salmon": "#fa8072", "sandybrown": "#f4a460", "seagreen": "#2e8b57", "seashell": "#fff5ee", "sienna": "#a0522d", "silver": "#c0c0c0", "skyblue": "#87ceeb", "slateblue": "#6a5acd", "slategray": "#708090", "snow": "#fffafa", "springgreen": "#00ff7f", "steelblue": "#4682b4",
      "tan": "#d2b48c", "teal": "#008080", "thistle": "#d8bfd8", "tomato": "#ff6347", "turquoise": "#40e0d0",
      "violet": "#ee82ee",
      "wheat": "#f5deb3", "white": "#ffffff", "whitesmoke": "#f5f5f5",
      "yellow": "#ffff00", "yellowgreen": "#9acd32"
    };

    if (typeof colours[colour.toLowerCase()] != 'undefined')
      return colours[colour.toLowerCase()];
    return '#ffffff';
  }

  initGroup(isDefault: boolean) {
    let rows = this.addCustomProductForm.get('rows') as FormArray;

    //Let show the default two rows for varient, ie. colors and Sizes
    if (isDefault && this.ProductId == undefined) {
      rows.push(this.formBuilder.group({
        optionName: "Colors",
        optionValue: [null],
      }));
      rows.push(this.formBuilder.group({
        optionName: "Size",
        optionValue: [''],
      }));
      // Add default Size OS at optionValue
      this.varientValues[1].push('OS');
    }
    //else {
    //  if (rows.length <= 2) {
    //    rows.push(this.formBuilder.group({
    //      optionName: [null],
    //      optionValue: [null],
    //    }));
    //  } else {
    //    this.notificationService.warning("Reached Max limit", "Warning")
    //  }
    //}

  }
  getUnits() {
    let units: IUnitInterface[] = [];
    units.push({ UnitId: 1, UnitText: 'Imperial (in/oz)' });
    units.push({ UnitId: 2, UnitText: 'Metric (cm/g)' });
    return units;
  };

  onDeleteRow(rowIndex) {
    let rows = this.addCustomProductForm.get('rows') as FormArray;
    rows.removeAt(rowIndex)
  }

  fn_GetSubCAtegories(item: any) {
    this.loader.show();
    for (var i = 0; i < item.length; i++) {
      var catId = Number(item[i].item_id);
      this.commonService.getSubCategories(Number(item[i].item_id)).subscribe((res: any) => {
        if (res.StatusCode == 200 && res.Data.ResponseData.length > 0) {
          let temp: ISubCategoryInterface[] = [];
          for (var i = 0; i < res.Data.ResponseData.length; i++) {
            temp.push({ item_id: res.Data.ResponseData[i].Value, item_text: res.Data.ResponseData[i].Text, CategoryId: catId });
          }
          this.dropdownListSubCategory = [].concat(this.dropdownListSubCategory, temp);

        }
      });
    }

    this.loader.hide();
  }

  public onItemSelect(item: any) {
    this.commonService.getSubCategories(Number(item.item_id)).subscribe((res: any) => {
      if (res.StatusCode == 200 && res.Data.ResponseData.length > 0) {
        let temp: ISubCategoryInterface[] = [];
        for (var i = 0; i < res.Data.ResponseData.length; i++) {
          temp.push({ item_id: res.Data.ResponseData[i].Value, item_text: res.Data.ResponseData[i].Text, CategoryId: item.item_id });
        }
        this.dropdownListSubCategory = [].concat(this.dropdownListSubCategory, temp);

      }
    });

  }
  //public onItemSelectsubCategories(item: any) {
  //}
  public onDeSelect(item: any) {

    this.dropdownListSubCategory = this.dropdownListSubCategory.filter(i => i.CategoryId != item.item_id);
  }
  fn_OpenUploadImageModal() {
    const dialogRef = this.dialog.open(UploadProductImageDialogComponent, {
      width: '700px',
      data: null
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      if (res == true) {

      }
    });
  }
  fn_GetCategories() {
    this.loader.show();
    this.commonService.getDropdownData().subscribe((res: any) => {
      if (res.StatusCode == 200) {
        let tmpCategory = [];
        for (let i = 0; i < res.Categories.length; i++) {
          tmpCategory.push({ item_id: res.Categories[i].Value, item_text: res.Categories[i].Text });
        }
        this.dropdownList = tmpCategory;

        let tmpColor = [];
        for (let i = 0; i < res.Colors.length; i++) {
          tmpColor.push({ ColorName: res.Colors[i].Text });
        }
        this.colorDropdownList = tmpColor;
        this.loader.hide();
      }
    });
  }
  get f() {
    return this.addCustomProductForm.controls;
  }
  imageCropped(image: ImageCroppedEvent, colorIndex: any) {
    if (image.base64) {
      this.ImageHashCombination[colorIndex].croppedImage = image.base64;
    } else if (image.blob) {
      const reader = new FileReader();
      reader.onloadend = () => {
        this.ImageHashCombination[colorIndex].croppedImage =
          reader.result as string;
      };
      reader.readAsDataURL(image.blob);
    }
  }
  imageLoaded(colorIndex: any) {
    this.ImageHashCombination[colorIndex].cropperReady = true;
  }
  loadImageFailed() {
    console.log('Load failed');
  }
  fn_AddImage(colorIndex) {
    if (this.ImageHashCombination[colorIndex].croppedImage != '') {

      let productImage: WarehouseImageModel = {
        Id: 0,
        Image: this.ImageHashCombination[colorIndex].croppedImage,
        IsAdded: true
      };
      this.ImageHashCombination[colorIndex].images.push(productImage);
    }

    this.inputImageVariable.filter((element, index) => index === colorIndex)[0].nativeElement.value = '';
    this.ImageHashCombination[colorIndex].cropperReady = false;
    this.ImageHashCombination[colorIndex].croppedImage = '';
  }
  fn_CancelCrop(colorIndex: any) {
    this.inputImageVariable.filter((element, index) => index === colorIndex)[0].nativeElement.value = '';
    this.ImageHashCombination[colorIndex].cropperReady = false;
    this.ImageHashCombination[colorIndex].croppedImage = '';
  }
  fn_DeleteImage(colorIndex: any, index: any, Id: number) {
    this.ImageHashCombination[colorIndex].images.splice(index, 1);

    if (Id > 0) {
      this.ImageHashCombination[colorIndex].deletedImages.push(Id);
    }
  }

  fn_OnFileChange(event, isAdd: boolean, colorIndex: any) {
    if (event.target.files && event.target.files[0]) {

      if (this.ImageHashCombination[colorIndex].images.length >= 4 && isAdd == true) {
        this.notificationService.info('Only 4 Images are allowed', 'Only 4 Images can be uploaded');
      }
      else {
        let file = event.target.files[0];
        const name = file.name;
        const type = file.type;
        const size = file.size;
        if (type !== 'image/jpeg' && type !== 'image/jpg' && type !== 'image/png') {
          this.inputImageVariable.filter((element, index) => index === colorIndex)[0].nativeElement.value = '';
          this.notificationService.info('Invalid type file', 'Type');
          return;
        }
        if (Math.round(size / 1024) >= 10048) {
          this.inputImageVariable.filter((element, index) => index === colorIndex)[0].nativeElement.value = '';
          this.notificationService.info('Size must be less than 10 Mb', 'Size');
          return;
        } else {
          this.ImageHashCombination[colorIndex].imageChangedEvent = event;
        }
      }
    }
  }
  AddCustomProduct(form: FormGroup) {
    if (this.varientValues.length == 0 || this.varientValues[0].length == 0) {
      this.notificationService.error('Please add at leaset one color in the varient', 'Validation');
      return false;
    }
    if (this.varientValues.length == 0 || this.varientValues[1].length == 0) {
      this.notificationService.error('Please add at leaset one size in the varient', 'Validation');
      return false;
    }

    let valMsg = '';
    this.ImageHashCombination.forEach(element => {
      if (element.images == undefined || element.images.length == 0) {
        valMsg += 'Please add at leaset one Image in the ' + element.Color + ' Color. \n';
      }
    });
    if (valMsg != '') {
      this.notificationService.error(valMsg, 'Validation');
      return false;
    }

    this.categoryList = [];
    this.loader.show();
    let addCustomProductDetails = form.value;
    addCustomProductDetails = {
      ...addCustomProductDetails,
      UserId: localStorage.getItem('userId'),
      CategoryList: [],
      ProductId: this.ProductId,
      ImageHashCombination: this.ImageHashCombination
    };
    // save colors and size
    addCustomProductDetails.rows[0].optionValue = this.varientValues[0].join(',');
    addCustomProductDetails.rows[1].optionValue = this.varientValues[1].join(',');

    for (var i = 0; i < addCustomProductDetails.Productsubcategories.length; i++) {
      if (this.dropdownListSubCategory.find(x => x.item_id == addCustomProductDetails.Productsubcategories[i].item_id)) {
        var index = this.dropdownListSubCategory.findIndex(x => x.item_id == addCustomProductDetails.Productsubcategories[i].item_id)
        this.categoryList.push({ categoryId: Number(this.dropdownListSubCategory[index].CategoryId), subCategoryId: Number(this.dropdownListSubCategory[index].item_id) })
      }      
    }


    for (var i = 0; i < addCustomProductDetails.ProductCategories.length; i++) {
      if (!this.categoryList.find(x => x.categoryId == addCustomProductDetails.ProductCategories[i].item_id)) {
        this.categoryList.push({ categoryId: Number(addCustomProductDetails.ProductCategories[i].item_id), subCategoryId: null })
      }
    }
    addCustomProductDetails.CategoryList = this.categoryList;
    let tmp = [];
    for (let i = 0; i < addCustomProductDetails.Productsubcategories.length; i++) {
      tmp.push({ CategoryId: addCustomProductDetails.Productsubcategories[i].item_id, ProductId: 0 });
    }
    addCustomProductDetails.ProductCategories = tmp;

    this.productService.addCustomProduct(addCustomProductDetails).subscribe((res: any) => {
      if (res.StatusCode == 200 && res.ProductId > 0) {
        this.loader.hide();
        this.notificationService.success(res.Message, "success");
        this.router.navigate(['store/productlisting']);
      }
    })

  }
  fn_viewProductdetais(productId: number) {
    this.route.navigate(['viewcustomdetail', productId], { relativeTo: this.activatedRoute.parent });
  }
}
